"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Overlay = void 0;

var _tokens = _interopRequireDefault(require("@paprika/tokens/lib/tokens"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _rawButton = _interopRequireDefault(require("@paprika/raw-button"));

var Overlay = (0, _styledComponents["default"])(_rawButton["default"]).withConfig({
  displayName: "Overlaystyles__Overlay",
  componentId: "sc-1bma9br-0"
})(function (_ref) {
  var zIndex = _ref.zIndex;
  return (0, _styledComponents.css)(["background-color:", ";box-sizing:content-box;display:block;height:100%;position:fixed;top:0;width:100%;", ";"], _tokens["default"].overlay.backdrop.backgroundColor, zIndex ? "z-index: ".concat(zIndex) : null);
});
exports.Overlay = Overlay;
//# sourceMappingURL=Overlay.styles.js.map